<template>
  <div class="appContainer">
    <v-row>
      <v-col md="4" cols="12">
        <v-card class="noMarginCard">
          <v-card-title primary-title class="justify-center"
            >Distribuzione geografica attacchi</v-card-title
          >
          <v-card-text primary-title class="justify-center">
            <GChart
              class="gChart"
              :settings="{ packages: ['corechart', 'geochart'] }"
              type="GeoChart"
              :data="geoDistribution"
              :options="{
                height: 290,
                colorAxis: { colors: ['red'] },
                align: 'center',
              }"
            />
          </v-card-text>
        </v-card> </v-col
      ><v-col md="4" cols="12">
        <v-card class="noMarginCard">
          <v-card-title primary-title class="justify-center"
            >Timeline attacchi</v-card-title
          >
          <v-card-text primary-title class="justify-center">
            <GChart
              class="gChart"
              :settings="{ packages: ['corechart'] }"
              type="LineChart"
              :data="timeline"
              :options="{
                height: 290,
                legend: { position: 'bottom' },
                align: 'center',
              }"
            />
          </v-card-text>
        </v-card> </v-col
      ><v-col md="4" cols="12">
        <v-card class="noMarginCard">
          <v-card-title primary-title class="justify-center"
            >Host attaccati</v-card-title
          >
          <v-card-text primary-title class="justify-center">
            <GChart
              class="gChart"
              :settings="{ packages: ['corechart'] }"
              type="PieChart"
              :data="attackedHosts"
              :options="{
                is3D: true,
                height: 290,
                legend: { position: 'bottom' },
                align: 'center',
              }"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-tabs v-model="tab" fixed-tabs background-color="primary" dark>
          <v-tab> Lista violazioni </v-tab>
          <v-tab> IP Bloccati </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card class="noMarginCard">
              <DataTables
                v-if="firewallData && firewallData.lastAttack"
                :headers="headers_violazioni"
                :dense="true"
                :itemPerPage="5"
                :tableData="firewallData.lastAttack"
                @blockIP="blockIP"
              ></DataTables>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="noMarginCard">
              <DataTables
                v-if="firewallData && firewallData.blockedIP"
                :headers="headers_blocked"
                :dense="true"
                :itemPerPage="5"
                :tableData="firewallData.blockedIP"
                @removeBlockedIP="removeBlockedIP"
                @switchBlockedIP="switchBlockedIP"
              ></DataTables>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  components: { GChart, DataTables },
  name: "mgmt-firewall",
  props: {
    dateInz: null,
    dateEnd: null,
  },
  data: () => ({
    timer: null,
    tab: 0,
    firewallData: null,
    headers_violazioni: [
      { text: "data/ora", value: "rqsTime", type: "datetime" },
      { text: "hostname", value: "hostname", type: "text" },
      { text: "method", value: "method", type: "text" },
      { text: "url", value: "url", type: "text" },
      { text: "nazione", value: "country", type: "text" },
      { text: "ip", value: "ipIcons", type: "icons" },
      { text: "intestatario", value: "person", type: "text" },
      { text: "msgId", value: "msgId", type: "text" },
      { text: "msgTxt", value: "msgTxt", type: "text" },
      { text: "Opzioni", value: "options", type: "buttons" },
    ],
    headers_blocked: [
      { text: "data/ora", value: "dateBlock", type: "datetime" },
      { text: "ip", value: "ip", type: "text" },
      { text: "nazione", value: "country", type: "text" },
      { text: "intestatario", value: "person", type: "text" },
      { text: "indirizzo", value: "address", type: "text" },
      { text: "telefono", value: "phone", type: "text" },
      { text: "Opzioni", value: "options", type: "buttons" },
    ],
  }),
  computed: {
    geoDistribution() {
      let resp = [];
      resp[0] = ["Nazione", "Attacchi"];
      if (this.firewallData && this.firewallData.geoDistribution) {
        for (let line of this.firewallData.geoDistribution) {
          resp.push([line.isoDex, line.tot]);
        }
      }
      return resp;
    },
    timeline() {
      let resp = [];
      resp[0] = ["Data/Ora", "Attacchi"];
      if (this.firewallData && this.firewallData.timeline) {
        for (let line of this.firewallData.timeline) {
          resp.push([new Date(line.rqsTime), line.tot]);
        }
      }
      return resp;
    },
    attackedHosts() {
      let resp = [];
      resp[0] = ["Hostname", "Attacchi"];
      if (this.firewallData && this.firewallData.attackedHosts) {
        for (let line of this.firewallData.attackedHosts) {
          resp.push([line.hostname, line.tot]);
        }
      }
      return resp;
    },
    refresh() {
      return this.$globalHandler.refresh.flag;
    },
  },
  watch: {
    dateInz(flag) {
      this.loadData();
      this.$globalHandler.refresh.flag = false;
    },
    dateEnd(flag) {
      this.loadData();
      this.$globalHandler.refresh.flag = false;
    },
    refresh(flag) {
      this.loadData();
      this.$globalHandler.refresh.flag = false;
    },
  },
  methods: {
    removeBlockedIP: async function (item) {
      let _ = this;
      let result = await Swal.fire({
        title: "Cancellare questo IP dalla lista ?",
        text: item.ip,
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "SI",
        cancelButtonText: "NO",
        buttonsStyling: true,
      });
      if (result.value) {
        let response = await _.chiamataAxios(
          "DELETE",
          "/mgmt/removeBlockedIP/" + item.ip
        );
        if (response.msg.esito) _.loadData();
      }
    },
    blockIP: async function (item) {
      let _ = this;
      let result = await Swal.fire({
        title: "Vuoi bloccare questo IP ?",
        text: item.fromIp,
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "SI",
        cancelButtonText: "NO",
        buttonsStyling: true,
      });
      if (result.value) {
        let response = await _.chiamataAxios(
          "POST",
          "/mgmt/blockIP/" + item.fromIp
        );
        if (response.msg.esito) _.loadData();
      }
    },
    switchBlockedIP: async function (item) {
      let _ = this;
      let response = await _.chiamataAxios(
        "POST",
        "/mgmt/switchBlockedIP/" + item.ip
      );
      if (response.msg.esito) _.loadData();
    },
    loadData: async function () {
      let _ = this;
      let dateInz = _.dateInz
        ? new Date(_.dateInz).toISOString().substr(0, 10)
        : "";
      let dateEnd = _.dateEnd
        ? new Date(_.dateEnd).toISOString().substr(0, 10)
        : "";
      let response = await _.chiamataAxios(
        "GET",
        "/mgmt/getFirewallDashboard?fromDate=" + dateInz + "&toDate=" + dateEnd
      );
      if (response.msg.esito) {
        _.firewallData = response.data;
        _.firewallData.blockedIP = _.firewallData.blockedIP.map((line) => {
          line.options = [
            {
              icon: "mdi-delete",
              color: "error",
              text: "Elimina IP",
              function: "removeBlockedIP",
            },
            {
              icon:
                line.blocked === 1 ? "mdi-shield-lock" : "mdi-shield-lock-open",
              color: line.blocked === 1 ? "error" : "green",
              text: line.blocked === 1 ? "Sblocca" : "Blocca",
              function: "switchBlockedIP",
            },
          ];
          return line;
        });
        _.firewallData.lastAttack = _.firewallData.lastAttack.map((line) => {
          line.options = [];
          line.ipIcons = [
            {
              icon: line.isBlocked ? "mdi-shield-lock" : "mdi-shield-lock-open",
              color: line.isBlocked ? "error" : "green",
              label: line.fromIp,
            },
          ];
          if (!line.isBlocked)
            line.options.push({
              icon: "mdi-shield-lock",
              color: "error",
              text: "Blocca",
              function: "blockIP",
            });
          return line;
        });
      }
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timer);
  },
  mounted() {
    this.loadData();
    this.timer = setInterval(this.loadData, 1000 * 60);
  },
};
</script>

<style type="text/css">
.appContainer {
  margin: 10px 20px;
}
.gChart table {
  margin: auto !important;
}
.chartLabel {
  text-align: center;
}
.sysInfo td {
  font-size: 12px !important;
}

.noMarginCard {
  margin-top: 0px !important;
  height: 100%;
  overflow: auto !important;
}
</style>